export default "/pdfs/Sean-Samborski-Engineering-Leader-Resume.pdf";